import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';

import { InputField, Input } from '@components/form';

const View: React.SFC<any> = ({ disabled }) => (
  <Grid fluid={true}>
    <Row>
      <Col className="grid-system-margin" />
    </Row>

    <Row>
      <Col md={12}>
        <h4>Poznámka</h4>
      </Col>
    </Row>
    <Row>
      <Col md={12}>
        <InputField
          component={Input}
          multiLine={true}
          id="note"
          name="note"
          label={'Poznámka'}
          disabled={disabled}
          style={{ maxHeight: '60vh' }}
          inputStyle={{ maxHeight: '60vh' }}
          textareaStyle={{ maxHeight: '56vh' }}
        />
      </Col>
    </Row>

    <Row>
      <Col className="grid-system-margin" />
    </Row>
  </Grid>
);

export default View;



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormNote.tsx